import { useState, useEffect } from 'react';
import { fetchVastaanottoDetails } from '@/services/vastaanottoService';

export const useVarausDetails = (varausId) => {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!varausId) return;

    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await fetchVastaanottoDetails(varausId);
        if (!cancelled) setDetails(res);
      }
      catch (e) {
        if (!cancelled) setError(e);
      }
      finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [varausId]);

  return { details, loading, error, setDetails };
};
